export const SET_SYMBOL_SEARCH_CONTENT = 'SET_SYMBOL_SEARCH_CONTENT';

export const setSymbolSearchContent = newContent => ({
  type: SET_SYMBOL_SEARCH_CONTENT,
  newContent,
});
